module.exports = __webpack_public_path__ + "img/signature_footer_logo.7636afab.svg";